import { SET_SNACKBAR } from './actionTypes'

export function setSnackbar(payload) {
  return {
    type: SET_SNACKBAR,
    payload,
  }
}
